import Enum from '@/modules/core/app/helpers/Enum';

export class GuidanceStepStageKey extends Enum {
  static CE_NOTIFY = 'ce_notify';
  static CE_NOTIFY_FINANCIAL_INSTITUTIONS = 'ce_notify_financial_institutions';
  static CE_NOTIFY_GOVERNMENT_CREDIT_AGENCIES = 'ce_notify_government_credit_agencies';
  static CE_APPLY_FOR_BENEFITS = 'ce_apply_for_benefits';
  static CE_PATH_AHEAD = 'ce_path_ahead';
  static CE_SECURE = 'ce_secure';
  static CE_INVENTORY = 'ce_inventory';
  static CE_PROBATE_DETERMINATION = 'ce_probate_determination';
  static CE_DISTRIBUTION_FRAMEWORK = 'ce_distribution_framework';
  static CE_PROBATE = 'ce_probate';
  static CE_NOTIFY_CREDITORS = 'ce_notify_creditors';
  static CE_FINALIZE_INVENTORY_VALUE = 'ce_finalize_inventory_value';
  static CE_ASSET_LIQUIDATION = 'ce_asset_liquidation';
  static CE_FILE_TAXES = 'ce_file_taxes';
  static CE_INTERIM_DISTRIBUTION = 'ce_interim_distribution';
  static CE_CLEARANCE = 'ce_clearance';
  static CE_FINAL_DISTRIBUTION = 'ce_final_distribution';
  static CE_PRE_PLAN = 'ce_pre_plan';

  static CV_PERSONAL_INFORMATION = 'cv_personal_information';
  static CV_INVENTORY = 'cv_inventory';
  static CV_DEFINE_YOUR_SITUATION = 'cv_define_your_situation';
  static CV_EXECUTORSHIP = 'cv_executorship';
  static CV_DISTRIBUTION_FRAMEWORK = 'cv_distribution_framework';
  static CV_FUNERAL_PRE_ARRANGEMENTS = 'cv_funeral_pre_arrangements';
  static CV_WILL = 'cv_will';
  static CV_POAS = 'cv_poas';
  static CV_TAXES_AND_OPTIMIZATIONS = 'cv_taxes_and_optimizations';
  static CV_EXECUTOR_PREP = 'cv_executor_prep';

  static CW_PERSONAL_INFORMATION = 'cw_personal_information';
  static CW_EXECUTORSHIP = 'cw_executorship';
  static CW_DISTRIBUTION_FRAMEWORK = 'cw_distribution_framework';
  static CW_FUNERAL_PRE_ARRANGEMENTS = 'cw_funeral_pre_arrangements';
  static CW_WILLS_AND_POAS = 'cw_will_and_poas';
}
